module.exports = __webpack_public_path__ + "af2f9d68064b8a0a77441591ebd5f858.png";